// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"c5b2e05f","158":"162c1634","298":"451a1511","473":"1caa0fd5","533":"61232313","787":"349b0e60","804":"c1e2f2b4","879":"d5ae1e16"}[chunkId] + ".chunk.js";
};